import React from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as EditIcon } from "icons/edit-green.svg";

type Props = {
  subscriptionId?: string | undefined;
  paymentId?: string | undefined;
  groupId?: string;
  groupName?: string;
};

const Subscription: React.FC<Props> = ({
  subscriptionId,
  paymentId,
  groupId,
  groupName,
}): JSX.Element => {
  let history = useHistory();

  return (
    <div className={"flex flex-col ml-96 w-1/2 items-end justify-end"}>
      <div className="flex h-16 w-auto bg-bt-white">
        <div className="flex flex-row my-auto mx-8">
          <div className="flex flex-col">
            <div className="flex flex-row">
              <span
                className="font-nunito text-base"
                style={{
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#878787",
                }}
              >
                Payment method:
              </span>
              <span
                className="ml-2 font-nunito text-base"
                style={{
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#2A2B31",
                }}
              >
                Card
              </span>
              {!paymentId ? (
                <button
                  className="ml-2"
                  onClick={() =>
                    history.push(`/manage-families/${groupId}/update-billing`, {
                      groupName,
                    })
                  }
                >
                  <EditIcon />
                </button>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="flex flex-col ml-16">
            <div className="flex flex-row">
              <span
                className="font-nunito text-base text-bt-gray-001"
                style={{
                  fontStyle: "normal",
                  fontWeight: 400,
                }}
              >
                Plan:
              </span>
              <span
                className="ml-2 font-nunito text-base text-bt-gray-700"
                style={{
                  fontStyle: "normal",
                  fontWeight: 400,
                }}
              >
                {!!paymentId ? "One Time" : "Monthly"}
              </span>
              {!paymentId ? (
                <button
                  className="ml-2"
                  onClick={() =>
                    history.push(`/manage-families/${groupId}/update-plan`, {
                      groupName,
                    })
                  }
                >
                  <EditIcon />
                </button>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
